import { ReactNode } from "react";

import {
  BulkActionActionConfirmationTabs,
  BulkActionItemID,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsDrawerActionStepsConfirmation from "components/BulkActions/Drawer/ActionSteps/Confirmation";
import BulkActionsDrawerActionStepsConfirmationEmptyTab from "components/BulkActions/Drawer/ActionSteps/Confirmation/EmptyTab";
import { StackRoleBindingView } from "shared/Stack/Roles/types";

import {
  StackRolesBulkActionsAnalyticsPayload,
  StackRolesBulkActionItem,
  StackRolesMutationVariables,
} from "./types";
import StackRolesBulkActionsSelectedItem from "./SelectedRoleItem";
import StackRolesBulkActionsConfirmActionForm from "./ConfirmActionForm";

type StackRolesBulkActionsConfirmationViewProps = {
  applicableItems: StackRoleBindingView[];
  skippedItems: StackRoleBindingView[];
  onItemDismiss: (id: BulkActionItemID) => void;
  selectedBulkAction: StackRolesBulkActionItem;
  onConfirm: (
    mutationVariables: StackRolesMutationVariables,
    analyticsPayload: StackRolesBulkActionsAnalyticsPayload
  ) => void;
  onCancel: () => void;
  customConfirmationMessage?: ReactNode;
};

const StackRolesBulkActionsConfirmationView = ({
  applicableItems,
  skippedItems,
  onItemDismiss,
  selectedBulkAction,
  onConfirm,
  onCancel,
  customConfirmationMessage,
}: StackRolesBulkActionsConfirmationViewProps) => {
  const getItems = (tab: BulkActionActionConfirmationTabs) => {
    if (tab === BulkActionActionConfirmationTabs.Applicable) {
      return applicableItems;
    }

    return skippedItems;
  };

  return (
    <>
      <BulkActionsDrawerActionStepsConfirmation
        applicableCount={applicableItems.length}
        skippedCount={skippedItems.length}
      >
        {({ currentTab }) =>
          getItems(currentTab).length === 0 ? (
            <BulkActionsDrawerActionStepsConfirmationEmptyTab currentTab={currentTab} />
          ) : (
            getItems(currentTab).map((item) => (
              <StackRolesBulkActionsSelectedItem
                key={item.id}
                item={item}
                onDismiss={onItemDismiss}
                itemCategory={currentTab}
                step={BulkActionsStep.ActionConfirmation}
              />
            ))
          )
        }
      </BulkActionsDrawerActionStepsConfirmation>

      <BulkActionsDrawerActionStepsFooter>
        <StackRolesBulkActionsConfirmActionForm
          variant={BulkActionsVariant.Drawer}
          action={selectedBulkAction}
          onConfirm={onConfirm}
          onCancel={onCancel}
          customConfirmationMessage={customConfirmationMessage}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default StackRolesBulkActionsConfirmationView;
